
import { defineComponent, PropType } from 'vue'
import { useThemeModel } from '@entities/theme'
export default defineComponent({
  name: 'AlertWaitingPromocode',
  props: {
    waitingPromocode: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    }
  },

  setup () {
    const themeModel = useThemeModel()

    return {
      themeModel
    }
  }
})
